<template>
  <div class="user" v-if="currentProfile">
    <div class="user__option">
      <div class="doctor">
        <img class="doctor__ava" src="@/assets/doctor.jpeg" alt="doctor" />
        <h4 class="doctor__name">{{ currentProfile.name }}</h4>
        <div class="doctor__contact">{{ currentProfile.email }}</div>
        <p class="doctor__gender">Пол: {{ currentProfile.gender.title }}</p>
      </div>
    </div>

    <div class="user__info">{{ user }}</div>

    <div class="btns" v-if="debug">
        <el-button @click="fake" type="success">FAKE SESSION</el-button>
        <el-button @click="logout">Выйти</el-button>
    </div>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'User',
  data () {
    return {}
  },
  created () {},
  computed: {
    ...mapState('session', {
      user: (state) => state.session
    }),
    ...mapState('auth', {
      currentProfile: (state) => state.profile
    }),
    debug () {
      // todo попросить Славу сделать нормальную переменную в env
      return (process.env.VUE_APP_ADMIN_API_BASE_URL.indexOf('develop') + 1)
    }
  },
  methods: {
    ...mapMutations({
      fake: 'session/FAKE_SESSION'
    }),
    logout () {
      this.$store
        .dispatch('auth/LOGOUT')
        .then(() => {
          this.$notify.success({
            title: 'Удачно...',
            message: 'До свидания!'
          })
        })
        .catch(() => {
          this.$notify.error({
            title: 'Упс...',
            message: 'Неудачная попытка'
          })
        })
        .finally(() => {
          this.$router.push({ name: 'auth.signin' })
        })
    }
  }
}
</script>

<style scoped lang="scss">
.user {
  background-color: #fff;
  color: #303133;
  transition: 0.3s;
  margin: 10px auto 0 auto;

  overflow: hidden;

  justify-content: space-between;
  align-items: center;
  max-width: 550px;
  box-shadow: none;

  border: 1px solid #dfe0eb;
  border-radius: 8px;

  &__option {
    color: #000;
    font-weight: 400;
    font-size: 16px !important;
    line-height: 26px;
  }

  &__option {
    background: linear-gradient(to top, #39a280, #53ecbb);
    padding: 30px 25px;
    border-radius: 5px 0;
    text-align: center;
    color: #fff;

    @media screen and (max-width: 600px) {
      padding: 10px 0;
      width: 100%;
      border-bottom-left-radius: 0;
    }

    & img {
      border-radius: 5px;
      margin-bottom: 10px;
    }
    & h4 {
      margin-bottom: 10px;
    }
    & p {
      font-size: 12px;
    }
  }

  &__btn {
    float: right;
    padding: 5px 6px;

    @media screen and (max-width: 600px) {
      float: none;
      margin: 0 auto 15px auto;
      display: block;
    }
  }

  &__info {
    margin: 20px 10px;
    color: #ccc;
  }
}
.profile-card {
  padding: 10px 20px;
  color: #000;

  &__name {
    font-weight: 500;
    font-size: 15px;
  }

  &__email {
    margin-top: 10px;
    font-size: 12px;
  }
}

.doctor {
  &__ava {
    width: 100px;
  }
  &__name {
    font-size: 16px;
  }
  &__contact {
    font-size: 13px;
  }
  &__gender {
    font-size: 12px;
    margin: 0;
  }
}

.btns {
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;

  .el-button {
    width: 100%;
    margin: 10px 0;
  }
}
</style>
